//
// Module for the Benefit Claims Index view
//
rs.module("participant/benefit/claims/index",

    [
        "common/select-helper",
        "controls/components/event-banner"
    ],

    function (selectHelper, eventBanner) {

        var _executeSelectionChanged;

        function initialize(jsSelectors, benefitClaimGrid, columnIds, backendUrls, constants) {

            // initialize js selectors
            var startClaimForm = $.js(jsSelectors.startClaimForm);
            var benefitClaimPaymentContainer = $.js(jsSelectors.benefitClaimPaymentContainer, { required: false });

            var systemCalculatedRadioButton = startClaimForm.js(jsSelectors.systemCalculatedRadioButton);
            var manualRadioButton = startClaimForm.js(jsSelectors.manualRadioButton);
            var claimTypeSelect = startClaimForm.js(jsSelectors.claimTypeSelect);
            var startClaimLink = startClaimForm.js(jsSelectors.startClaimLink);

            // initialize select helpers
            var claimTypeSelectHelper = selectHelper.getHelper(claimTypeSelect);

            // hook up click event for Start Claim link
            startClaimLink.click(event, startClaim);

            // on system calculated calculation type selected - reload list of system calculated claim types
            systemCalculatedRadioButton.change(function () {

                if ($(this).is(":checked")) {
                    claimTypeSelectHelper.replaceOptions(constants.systemCalculatedClaimTypes, { withBlank: true, maintainSelection: true });
                }
            });

            // on manual calculation type selected - reload list of manual claim types, excluding DRO
            manualRadioButton.change(function () {

                if ($(this).is(":checked")) {
                    claimTypeSelectHelper.replaceOptions(constants.manualClaimTypes, { withBlank: true, maintainSelection: true });
                }
            });

            // start claim event handler
            function startClaim() {

                // validate form before proceeding
                var validator = startClaimForm.validate();
                var isValid = validator.form();

                if (isValid) {

                    // make backend call to get url to appropriate benefit setup wizard, and redirect there
                    $.get(
                        backendUrls.getStartClaimRedirectUrl,
                        {
                            isSystemCalculated: systemCalculatedRadioButton.is(":checked"),
                            claimType: claimTypeSelect.val()
                        },
                        function (data) {
                            window.location.href = data;
                        }
                    );
                }
                else {
                    return false;
                }
            }

            // on grid selection changed - reload benefit claim payment detail partial view
            if (benefitClaimGrid) {

                benefitClaimGrid.selectionChanged(function (values, rows) {

                    // This handler fires when the grid is first rendered, but we don't want it to in our case
                    // _executeSelectionChanged will be false the first time it runs, after that this will fire every time a row is clicked
                    if (_executeSelectionChanged && values.length > 0) {
                        
                        eventBanner.removeAllMessages();

                        $.get(
                            backendUrls.getBenefitClaimPayment,
                            {
                                benefitClaimKey: rows[0][columnIds.benefitClaimKey]
                            },
                            function (data) {
                                benefitClaimPaymentContainer.html(data);
                            }
                        );
                    }

                    _executeSelectionChanged = true;
                });
            }
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);